import * as React from 'react';

import { invoiceReducer, initialState } from './reducer';

const InvoiceContext = React.createContext()

export function useInvoice() {
   const context = React.useContext(InvoiceContext)
   if (context === undefined) {
      throw new Error(`Can't use "useGlobal" without an GlobalProvider!`);
   }
   return context
}
 
export function InvoiceProvider({ children }) {
   const [state, dispatch] = React.useReducer(invoiceReducer, initialState);

   return (
      <InvoiceContext.Provider value={{ state, dispatch }}>
         {children}
      </InvoiceContext.Provider>
   )
}